import { render, staticRenderFns } from "./HelloPrinta.vue?vue&type=template&id=1dbc51ea&lang=pug"
import script from "./HelloPrinta.vue?vue&type=script&lang=js"
export * from "./HelloPrinta.vue?vue&type=script&lang=js"
import style0 from "./HelloPrinta.vue?vue&type=style&index=0&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports